import PenIcon from "@/components/atoms/icons/PenIcon";
import LandlinePhone from "@/components/atoms/icons/LandlinePhone";
import TiktokIcon from "@/components/atoms/icons/TiktokIcon";
import InstagramIcon from "@/components/atoms/icons/IntagramIcon";
import FacebookIcon from "@/components/atoms/icons/FacebookIcon";
import CityIcon from "@/components/atoms/icons/CityIcon";
import UserIcon from "@/components/atoms/icons/UserIcon";
import PiggyIcon from "@/components/atoms/icons/PiggyIcon";
import ApertureIcon from "@/components/atoms/icons/Aperture";
import { Field } from "./types";
import {
  IMG_CUSTOMMER1,
  IMG_CUSTOMMER2,
  IMG_CUSTOMMER3,
  IMG_LOGO_CANON,
  IMG_LOGO_DNP,
  IMG_LOGO_PAYOS,
  IMG_CUSTOMER4,
  IMG_CUSTOMER5,
} from "./imagesUrl";
import { TFunction } from "i18next";

interface Link {
  href: string;
  label: string;
}

interface SocialLink extends Link {
  icon: React.ComponentType;
}

export const NAVBAR_LINKS = (t: TFunction) => [
  {
    id: "home",
    title: t("navbar.home"),
  },
  {
    id: "blog",
    title: t("navbar.blog"),
  },
  {
    id: "machines",
    title: t("navbar.machines"),
  },
  {
    id: "ebooks",
    title: t("navbar.ebooks"),
  },
  {
    id: "contactForm",
    title: t("navbar.contactForm"),
  },
  // {
  //   id: "careers",
  //   title: "Tuyển dụng",
  // },
];

export const socialLinks: SocialLink[] = [
  {
    href: "https://www.instagram.com/snapbox_tongkhophotobooth/",
    label: "Instagram",
    icon: InstagramIcon,
  },
  {
    href: "https://www.facebook.com/snapboxvietnamjsc/",
    label: "Facebook",
    icon: FacebookIcon,
  },
  {
    href: "https://www.tiktok.com/@snapbox_photobooth",
    label: "Tiktok",
    icon: TiktokIcon,
  },
];

export const footerLinks = (t: TFunction): Link[] => [
  { href: "/privacy-policy", label: t("footer.privacy_policy") },
  { href: "/copyright", label: t("footer.copyright") },
  { href: "/terms-of-use", label: t("footer.terms_of_use") },
  // { href: "/careers", label: "Tuyển dụng" },
];

export const cardsWhyPhotoBooth = (t: TFunction) => [
  {
    description: t("home.why.cards.description1"),
    icon: PiggyIcon,
  },
  {
    description: t("home.why.cards.description2"),
    icon: CityIcon,
  },
  {
    description: t("home.why.cards.description3"),
    icon: UserIcon,
  },
];

export const fbChatUrl = "https://www.facebook.com/messages/t/106409758638789";

export const contactDirectly = {
  phone_1: "+84869757033",
  zaloChatUrl_1: "https://zalo.me/0869757033",
  phone_2: "+84399010131",
  zaloChatUrl_2: "https://zalo.me/0399010131",
  fbChatUrl: fbChatUrl,
};

export const CONTACT_DIRECTLY_BTNS = () => [
  {
    iconType: "zalo",
    label: "Chat Zalo",
    children: [
      {
        subtitle: "0869 757 033",
        action: () => window.open(contactDirectly.zaloChatUrl_1, "_blank"),
      },
      {
        subtitle: "0399 010 131",
        action: () => window.open(contactDirectly.zaloChatUrl_2, "_blank"),
      },
    ],
  },
  {
    iconType: "call",
    label: "Hotline",
    children: [
      {
        subtitle: "0869 757 033",
        action: () => (window.location.href = `tel:${contactDirectly.phone_1}`),
      },
      {
        subtitle: "0399 010 131",
        action: () => (window.location.href = `tel:${contactDirectly.phone_2}`),
      },
    ],
  },
];

export const photoboothBenefits = (t: TFunction) => [
  {
    icon: ApertureIcon,
    heading: t("photobooth_benefits.benefit1.heading"),
    text: t("photobooth_benefits.benefit1.text"),
  },
  {
    icon: PenIcon,
    heading: t("photobooth_benefits.benefit2.heading"),
    text: t("photobooth_benefits.benefit2.text"),
  },
  {
    icon: LandlinePhone,
    heading: t("photobooth_benefits.benefit3.heading"),
    text: t("photobooth_benefits.benefit3.text"),
  },
];

export const fields = (t: TFunction): Field[] => [
  {
    label: t("fields.name.label"),
    name: "name",
    type: "text",
    placeholder: t("fields.name.placeholder"),
    required: true,
  },
  {
    label: t("fields.email.label"),
    name: "email",
    type: "email",
    placeholder: t("fields.email.placeholder"),
    required: true,
  },
  {
    label: t("fields.phoneNumber.label"),
    name: "phoneNumber",
    type: "text",
    placeholder: t("fields.phoneNumber.placeholder"),
    required: true,
    additionalInfo: t("fields.phoneNumber.additionalInfo"),
  },
  {
    label: t("fields.address.label"),
    name: "address",
    type: "text",
    placeholder: t("fields.address.placeholder"),
  },
  {
    label: t("fields.investment.label"),
    name: "investment",
    type: "textarea",
    placeholder: t("fields.investment.placeholder"),
    rows: 4,
  },
];

export const TAG_ALL_VALUE = "Tất cả";

export const TAG_DEFAULT_OPTION = {
  name: "Tất cả",
  name_en: "All",
  name_kr: "전체",
  name_vi: "Tất cả",
};

export const partnerLogos = [
  { src: IMG_LOGO_CANON, alt: "Logo Canon" },
  { src: IMG_LOGO_DNP, alt: "Logo DNP" },
  { src: IMG_LOGO_PAYOS, alt: "Logo Payos" },
];

export const testimonials = (t: TFunction) => [
  {
    image: IMG_CUSTOMMER1,
    text: t("testimonials.testimonial1"),
  },
  {
    image: IMG_CUSTOMMER3,
    text: t("testimonials.testimonial2"),
  },
  {
    image: IMG_CUSTOMMER2,
    text: t("testimonials.testimonial3"),
  },
  {
    image: IMG_CUSTOMER4,
    text: t("testimonials.testimonial4"),
  },
  {
    image: IMG_CUSTOMER5,
    text: t("testimonials.testimonial5"),
  },
];
